/* eslint-disable no-unused-vars */
import React from "react";
import { useNavigate } from "react-router-dom";
import { FaFileInvoice, FaUsers, FaCalendarCheck } from "react-icons/fa";

const reports = [
     {
    title: "Booking Report",
    path: "/admin",
    icon: <FaFileInvoice />,
    description: "Detailed booking records",
  },
  {
    title: "Customer Ledger",
    path: "/admin/reports/customer-ledger",
    icon: <FaUsers />,
    description: "View customer-wise transaction history",
  },
  {
    title: "Upcoming Bookings",
    path: "/admin/reports/advance-bookings",
    icon: <FaCalendarCheck />,
    description: "Upcoming and advance bookings",
  },
  {
    title: "Advance Requirements",
    path: "/admin/reports/advance-bookings",
    icon: <FaCalendarCheck />,
    description: "Upcoming and advance bookings",
  },
 
];

const Reports = () => {
  const navigate = useNavigate();

  return (
    <div className="py-6">
      <h1 className="text-3xl text-center font-bold m-8 flex items-center justify-center gap-2">
            <FaFileInvoice className="text-blue-600" /> 
            Reports & Analytics 
        {/* Dashboard */}
      </h1>

      <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6">
        {reports.map((report, index) => (
          <div
            key={index}
            onClick={() => window.open(report.path, "_blank")}
            className="cursor-pointer bg-white rounded-2xl shadow-md p-5 hover:shadow-xl hover:scale-105 transition-all duration-300 border border-gray-100"
          >
            <div className="text-3xl text-blue-600 mb-3">
              {report.icon}
            </div>

            <h2 className="text-lg font-semibold text-gray-800">
              {report.title}
            </h2>

            <p className="text-sm text-gray-500 mt-1">
              {report.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reports;